import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IStockInput } from "../domain/IStockInput";
import { DailyTableService } from "../services/dt.service";

interface dtStockInputState {
  loading: boolean;
  stockInputs: IStockInput[];
  error: any;
}

const initialState: dtStockInputState = {
  loading: false,
  stockInputs: [],
  error: undefined,
};

export const getStateOfStockInput = createAsyncThunk(
  "DailyTable/getStateOfStockInput",
  async () => {
    try {
      const result = await DailyTableService.getStateOfStockInput();
      return result.inputs;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtStockInputSlice = createSlice({
  name: "StockInput",
  initialState: initialState,
  reducers: {
    setStockInput: (state, action: PayloadAction<IStockInput[]>) => {
      state.stockInputs = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStateOfStockInput.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStateOfStockInput.fulfilled, (state, action) => {
      state.stockInputs = action.payload ? action.payload : [];
      state.loading = false;
    });
    builder.addCase(getStateOfStockInput.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.dailytable.inputs;

export const { setError } = dtStockInputSlice.actions;

export default dtStockInputSlice.reducer;
